import ReceiptCrud from "../components/receipt/ReceiptCrud";

const ReceiptsPage = () => {
  return <ReceiptCrud />;
};

export default ReceiptsPage;
